import * as Yup from 'yup';

import { DifficultyLevel } from '../../../../../../Model/Program';
import { LocationType, TrackType } from '../../../../../../Model/Track';
import {
  fieldName,
  programAttributes,
} from './formFields';

import texts from './texts';

const DEFAULT_NO_OF_PROGRAMS = 1;

const initialProgramValues = {
  [programAttributes.ID]: null,
  [programAttributes.LABEL]: '',
  [programAttributes.PROGRAM]: null,
  [programAttributes.EQUIPMENT]: [],
  [programAttributes.REPEAT_COUNT]: 1,
};

const initialValues = {
  [fieldName.NAME]: '',
  [fieldName.PROGRAMS]: Array(DEFAULT_NO_OF_PROGRAMS).fill().map(() => ({ ...initialProgramValues })),
  [fieldName.TYPE]: TrackType.STANDARD,
  [fieldName.DIFFICULTY]: DifficultyLevel.BEGINNER,
  [fieldName.LOCATION]: LocationType.HOME,
  [fieldName.EQUIPMENT]: [],
};

const validationSchema = Yup.object().shape({
  [fieldName.NAME]: Yup.string().required(texts.validation.requiredField),
  [fieldName.PROGRAMS]: Yup.array()
    .test('has-program', texts.validation.programRequired,
      (programs) => programs?.some((program) => program?.id)),
});

export {
  initialValues,
  validationSchema,
  initialProgramValues,
};
